import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=46ba778a&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=46ba778a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports